import {A, Box, Flex, Text, Title} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC} from 'react'

import {useLegalLang} from '../../../components/legal/use-legal-lang'
import {legalPath} from '../../../legal/legal-helpers'
import {SignUpFormType} from '../../../services/auth/forms/sign-up-form'
import {useAppLoading} from '../../../services/global/hooks'
import {Button} from '../../../ui/components/button/button'
import {CheckBox} from '../../../ui/components/input/checkbox'
import {Input} from '../../../ui/components/input/input'
import {useLocale} from '../../../utils/i18n'

type PasswordSignUpStepProps = {
  backAction?: (e: Event) => void
  handleGoToNextStep: () => void
}

export const PasswordSignUpStep: FC<PasswordSignUpStepProps> = ({backAction, handleGoToNextStep}) => {
  const {l} = useLocale()
  const {isLoading} = useAppLoading()
  const legalLang = useLegalLang()
  const {values, validateForm} = useFormikContext<SignUpFormType>()

  const handleNext = () => {
    (async () => {
      const validationResult = await validateForm(values)
      const hasErrors =
        Boolean(validationResult.password) ||
        Boolean(validationResult.passwordCheck) ||
        Boolean(validationResult.termsAndConditionsConfirm)
      if (!hasErrors) {
        handleGoToNextStep()
      }
    })()
  }

  return (
    <Box pb={'24px'}>
      <Flex mb='8px'>
        <Title
          text={l('letsCreateAcc')}
          styleType='h2'
        />
      </Flex>
      <Flex mb='16px'>
        <Text text={l('createPassDescription', {email: values.email})} />
      </Flex>
      <Input
        label={l('password')}
        id={'password'}
        type='password'
      />
      <Input
        label={l('passwordVerify')}
        id={'passwordCheck'}
        type='password'
      />
      <Flex
        mt='24px'
        mb='16px'
      >
        <CheckBox id='termsAndConditionsConfirm'>
          <Flex ml='16px'>
            <Text>
              {l('i_accept_to_be_contacted_at_this_email', {caseAction: 'capitalize'})}
              {'. '}
              {l('more_about', {caseAction: 'capitalize'})}{' '}
              <A
                href={legalPath('terms', legalLang)}
                target='_blank'
                rel='noopener noreferrer'
              >
                {l('termsConditions')}
              </A>
              {l('and')}
              <A
                href={legalPath('privacy', legalLang)}
                target='_blank'
                rel='noopener noreferrer'
              >
                {l('privacyPolicy')}
              </A>
            </Text>
          </Flex>
        </CheckBox>
      </Flex>
      <Flex
        gap='16px'
        mt={'16px'}
      >
        {backAction && (
          <Button
            type='secondary'
            disabled={isLoading}
            onClick={backAction}
          >
            {l('back')}
          </Button>
        )}
        <Button
          isLoading={isLoading}
          onClick={handleNext}
        >
          {l('next', {caseAction: 'capitalize'})}
        </Button>
      </Flex>
    </Box>
  )
}
